import React, { useState } from 'react';
import { Container, Paper, Title, Divider, SegmentedControl, Stack } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import GoogleAuthButton from '../components/auth/GoogleAuthButton';
import EmailSignInForm from '../components/auth/EmailSignInForm';
import EmailSignUpForm from '../components/auth/EmailSignUpForm';

export default function AuthPage() {
  const [mode, setMode] = useState('signin');
  const navigate = useNavigate();

  const handleSuccess = () => navigate('/app');

  return (
    <Container size={420} my={40}>
      <Title align="center">{mode === 'signin' ? 'Welcome back!' : 'Create your account'}</Title>
      <Paper withBorder shadow="md" p="lg" mt="xl" radius="md">
        <Stack>
          <SegmentedControl
            fullWidth
            data={[
              { label: 'Sign in', value: 'signin' },
              { label: 'Sign up', value: 'signup' },
            ]}
            value={mode}
            onChange={setMode}
          />
          <GoogleAuthButton onSuccess={handleSuccess} />
          <Divider label="Or continue with email" labelPosition="center" />
          {mode === 'signin' ? (
            <EmailSignInForm onSuccess={handleSuccess} />
          ) : (
            <EmailSignUpForm onSuccess={handleSuccess} />
          )}
        </Stack>
      </Paper>
    </Container>
  );
}
